// @flow

import publicApiService from './public-api-service';
import { createResourceModel } from './../utils/health-resources';

const accessToken = (token) => localStorage.getItem(`access_token_${token}`);

class ShareService {
  getSharedResource(token: string) {
    return publicApiService
      .get(`/public/shared-resources/${token}`)
      .then((response) => response.viewer);
  }

  sendPasscodeEmail(token) {
    return publicApiService
      .get(`/public/shared-resources/${token}/send`);
  }

  verifyPasscode(token: string, passcode: string): Promise<any> {
    const aToken = accessToken(token);
    return publicApiService
      .post(`/public/shared-resources/${token}`, {
        viewer: { passcode }
      }, {
        headers: {
          Authorization: `Bearer ${aToken}`
        }
      })
      .then((response) => response); // response is authenticated access token
  }

  checkViewerAccess(token: string): Promise<any> {
    /* Check if the user already has a valid access token for this viewer */
    const aToken = accessToken(token);
    return publicApiService
      .post(`/public/shared-resources/${token}`, {}, {
        headers: {
          Authorization: `Bearer ${aToken}`
        }
      })
      .then((response) => response); // response is the same access token if it is authenticated
  }

  // get all shared resources for a single viewer to display on dash
  getResources(token: string): Promise<any> {
    const aToken = accessToken(token);
    return publicApiService
      .get(`/public/shared/${token}/resources`,
        { headers: {
          Authorization: `Bearer ${aToken}` } })
      .then((res) => {
        const modResources = res &&
          res.resources &&
          res.resources.resources &&
          res.resources.resources.map((r) => createResourceModel(r));
        return modResources;
      });
  }

  // gets single resource + files & nested resources
  getSingleResource(token: string, id: number): Promise<any> {
    const aToken = accessToken(token);
    return publicApiService
      .get(`/public/shared/${token}/resources/${id}/?include=related`,
        { headers: { Authorization: `Bearer ${aToken}` } })
      .then((response) => createResourceModel(response.resource));
  }

  getFile(token: string, recordID: number, fileID: number): Promise<any> {
    const aToken = accessToken(token);
    return publicApiService
      .get(`/public/shared/${token}/resources/${recordID}/file/${fileID}`,
        { headers: {
          Authorization: `Bearer ${aToken}` } })
      .then((response) => response.file);
  }

  viewFile(token: string, recordID: number, fileID: number): Promise<any> {
    const aToken = accessToken(token);
    return publicApiService
      .get(`/public/shared/${token}/resources/${recordID}/file/${fileID}/view`,
        { headers: {
          Authorization: `Bearer ${aToken}` },
        responseType: 'blob' })
      .then((response) => new Blob([response], { type: response.type }));
  }

  viewThumb(token: string, recordID: number, fileID: number): Promise<any> {
    const aToken = accessToken(token);
    return publicApiService
      .get(`/public/shared/${token}/resources/${recordID}/file/${fileID}/thumb`,
        { headers: {
          Authorization: `Bearer ${aToken}` },
        responseType: 'blob' })
      .then((response) => new Blob([response], { type: response.type }));
  }
}

export default new ShareService();


// WEBPACK FOOTER //
// ./src/services/share-service.js